import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

export const LazyRedirect = lazy(
  () => import(/* webpackChunkName: 'RedirectApp' */ './index'),
);

export default function RedirectApp(props) {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyRedirect {...props} />
    </Suspense>
  );
}
